/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, IconClose, Text } from '@bbl-digital/snorre'
import React from 'react'
import { Step } from 'react-joyride'
import { useDispatch } from 'react-redux'
import { GUIDE_COMPLETED_REQUESTED } from 'shared/store/guides/actionTypes'
import { SKIP_ALL_GUIDES } from '../../constants/guides'
import {
  CloseWrapper,
  BigTooltipBody,
  TooltipContent,
  TooltipFooter,
  HeaderWrapper,
} from './styles'

interface IProps {
  continuous: boolean
  index: number
  size: number
  step: Step
  backProps: any
  skipProps: any
  closeProps: any
  primaryProps: any
  tooltipProps: any
}

const GuideModal = ({
  continuous,
  index,
  size,
  step,
  skipProps,
  closeProps,
  primaryProps,
  tooltipProps,
}: IProps) => {
  const dispatch = useDispatch()

  const skipAll = () => {
    dispatch({
      type: GUIDE_COMPLETED_REQUESTED,
      payload: SKIP_ALL_GUIDES,
    })
  }

  return (
    <BigTooltipBody {...tooltipProps} padding={step.title ? '1.5em' : '2em'}>
      {!step.title && (
        <CloseWrapper>
          <Button nostyle {...closeProps}>
            <IconClose color="black" />
          </Button>
        </CloseWrapper>
      )}
      {step.title && (
        <HeaderWrapper>
          <Text bold>{step.title}</Text>
        </HeaderWrapper>
      )}
      <TooltipContent>{step.content}</TooltipContent>
      <TooltipFooter>
        <Button
          nostyle
          onClick={skipAll}
          trackingName="Felles"
          trackingEvent="Guide: Ikke nå"
        >
          Ikke nå
        </Button>
        {continuous && index + 1 < size && (
          <Button
            {...primaryProps}
            small={step.title}
            trackingName="Felles"
            trackingEvent="Guide: Neste"
          >
            Neste
          </Button>
        )}
        {continuous && index + 1 === size && (
          <Button
            {...primaryProps}
            small={step.title}
            trackingName="Felles"
            trackingEvent="Guide: Lukk"
          >
            Lukk
          </Button>
        )}
        {!continuous && (
          <Button
            {...closeProps}
            small={step.title}
            trackingName="Felles"
            trackingEvent="Guide: Lukk"
          >
            Lukk
          </Button>
        )}
      </TooltipFooter>
    </BigTooltipBody>
  )
}

export default GuideModal
